<footer class="page-footer padding_top_20 max-width" [ngClass]="isLogged() ? 'footer-logged': ' footer-not-logged'">

    <div class="content-footer-container legal_backgound d-flex justify-content-evenly">
        <div class="content-footer space-between padding_bottom_20">
            <ul class="legaladvice footer_list">
                <li><a target="_blank" href="{{Etiquetas.CondicionesUso.Link}}">{{Etiquetas.CondicionesUso.Titulo}}</a>
                </li>
                <li><a target="_blank"
                        href="{{Etiquetas.PoliticaDePrivacidad.Link}}">{{Etiquetas.PoliticaDePrivacidad.Titulo}}</a>
                </li>
                <li><a target="_blank" href="{{Etiquetas.PieDeImprenta.Link}}">{{Etiquetas.PieDeImprenta.Titulo}}</a>
                </li>
                <li><a target="_blank"
                        href="{{Etiquetas.DetallesTecnicos.Link}}">{{Etiquetas.DetallesTecnicos.Titulo}}</a></li>
            </ul>

        </div>

        <div class="service-footer-container space-between">
            <div class="service-footer padding_top_20">
                <div class="service-footer__col">
                    <ul class="follow-us margin_left_20">

                        <li class="follow-us__item"><a href="{{Etiquetas.SocialMedia.Facebook}}"
                                matTooltip="{{Etiquetas.Tooltips.Facebook}}" target="_blank" class="footer_link"
                                [ngClass]="isLogged() ? 'link-fb-logged': 'link-fb-not-logged'">Facebook</a></li>
                        <li class="follow-us__item"><a href="{{Etiquetas.SocialMedia.Instagram}}"
                                matTooltip="{{Etiquetas.Tooltips.Instagram}}" target="_blank" class="footer_link"
                                [ngClass]="isLogged() ? 'link-ig-logged': 'link-ig-not-logged'"
                                data-placement="left">Instagram</a></li>
                        <li matTooltip="{{Etiquetas.Tooltips.Twitter}}" class="follow-us__item"><a
                                href="{{Etiquetas.SocialMedia.Twitter}}" target="_blank" class="footer_link"
                                [ngClass]="isLogged() ? 'link-tw-logged': 'link-tw-not-logged'"
                                data-src-matTooltip="Follow Us on Twitter">Twitter</a></li>
                        <li class="follow-us__item"><a href="{{Etiquetas.SocialMedia.YouTube}}"
                                matTooltip="{{Etiquetas.Tooltips.YouTube}}" target="_blank" class="footer_link"
                                [ngClass]="isLogged() ? 'link-yt-logged': 'link-yt-not-logged'">YouTube</a></li>
                        <li class="follow-us__item"><a href="{{Etiquetas.SocialMedia.Linkedin}}"
                                matTooltip="{{Etiquetas.Tooltips.Linkedin}}" target="_blank" class="footer_link"
                                [ngClass]="isLogged() ? 'link-li-logged': 'link-li-not-logged'">LinkedIn</a></li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</footer>

<!-- <footer class="page-footer padding_top_20 max-width">
  <div class="inicio_bg_footer"></div>
  <div class="content-footer-container legal_backgound d-flex">
      <div class="service-footer-container space-between">
          <div class="service-footer padding_top_20">
              <div class="service-footer__col">
                  <ul class="follow-us margin_left_20">
                      <h6>Seguinos</h6>
                      <li class="follow-us__item"><a href="{{Etiquetas.SocialMedia.Facebook}}"
                              matTooltip="{{Etiquetas.Tooltips.Facebook}}"  target="_blank"
                              class="follow-us__link follow-us__link--fb">Facebook</a></li>
                      <li matTooltip="{{Etiquetas.Tooltips.Twitter}}" class="follow-us__item"><a
                              href="{{Etiquetas.SocialMedia.Twitter}}"  target="_blank"
                              class="follow-us__link follow-us__link--tw"
                              data-src-matTooltip="Follow Us on Twitter">Twitter</a></li>
                      <li class="follow-us__item"><a href="{{Etiquetas.SocialMedia.YouTube}}"
                              matTooltip="{{Etiquetas.Tooltips.YouTube}}"  target="_blank"
                              class="follow-us__link follow-us__link--yt">YouTube</a></li>
                      <li class="follow-us__item"><a href="{{Etiquetas.SocialMedia.Linkedin}}"
                              matTooltip="{{Etiquetas.Tooltips.Linkedin}}"  target="_blank"
                              class="follow-us__link follow-us__link--li">LinkedIn</a></li>
                      <li class="follow-us__item"><a href="{{Etiquetas.SocialMedia.Instagram}}"
                              matTooltip="{{Etiquetas.Tooltips.Instagram}}"  target="_blank"
                              class="follow-us__link follow-us__link--ig" data-placement="left">Instagram</a></li>
                  </ul>
              </div>
          </div>
      </div>
      <div class="content-footer space-between padding_bottom_20">
          <ul class="legaladvice footer_list">
              <li><a href="{{Etiquetas.CondicionesUso.Link}}">{{Etiquetas.CondicionesUso.Titulo}}</a></li>
              <li><a href="{{Etiquetas.PoliticaDePrivacidad.Link}}">{{Etiquetas.PoliticaDePrivacidad.Titulo}}</a></li>
              <li><a href="{{Etiquetas.PieDeImprenta.Link}}">{{Etiquetas.PieDeImprenta.Titulo}}</a></li>
              <li><a href="{{Etiquetas.DetallesTecnicos.Link}}">{{Etiquetas.DetallesTecnicos.Titulo}}</a></li>
          </ul>
          <div class="printfooter"></div>
      </div>
      <div class="content-footer-container colored_cright">
          <div class="content-footer">
              <div loading="lazy" decoding="async" class="cright-item"><img src="assets/images/logo_bayer_blanco.png"
                      alt="..." class="logo_footer"> {{Etiquetas.CopyrightFooter}}</div>
          </div>
      </div>
  </div>
</footer> -->